import { render, staticRenderFns } from "./root-chat.vue?vue&type=template&id=66989cc2"
import script from "./root-chat.vue?vue&type=script&lang=js"
export * from "./root-chat.vue?vue&type=script&lang=js"
import style0 from "./root-chat.vue?vue&type=style&index=0&id=66989cc2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports